
// const hideValues = false

import ApiService from './ApiService'

class AIService {
    getFullPrompts = async (apiToken) => {
        let url = '/ai/prompts-admin'

        let params = {}
        try {
        // Need to change this to a POST
        var response = await ApiService.get(apiToken, url, params)
        } catch (err) {
            console.error(err)
        }
        return response
    }

    getFullPrompt = async (apiToken, id) => {
        let url = '/ai/prompts-admin/' + id

        let params = {}
        try {
        // Need to change this to a POST
        var response = await ApiService.get(apiToken, url, params)
        } catch (err) {
            console.error(err)
        }
        return response
    }

    updatePrompt = async (apiToken, id, promptData) => {
        let url = '/ai/prompt/' + id

        let params = {}
        let body = { prompt: promptData }

        try {
        var response = await ApiService.put(apiToken, url, params, body)
        } catch (err) {
        console.error(err)
        return {
            error: 'Error updating prompt: ' + err.message
        }
        }
        return response
    }

    createPrompt = async (apiToken, promptData) => {
        let url = '/ai/prompt'

        let params = {}
        let body = { prompt: promptData }

        try {
            var response = await ApiService.post(apiToken, url, params, body)
        } catch (err) {
            console.error(err)
            return {
                error: 'Error updating prompt: ' + err.message
            }
        }
        return response
    }

    deletePrompt = async (apiToken, id) => {
        let url = '/ai/prompt/' + id

        let params = {}

        try {
            var response = await ApiService.sendDelete(apiToken, url, params)
        } catch (err) {
            console.error(err)
            return {
                error: 'Error updating prompt: ' + err.message
            }
        }
        return response
    }

}
export default new AIService()

